import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AutoUnsubscribe } from '../../auto-unsubscribe.decorator';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

export interface TextInputData {
  title: string;
  message?: string;
  initialValue?: string;
  placeholder?: string;
  required?: boolean;
}

@AutoUnsubscribe()
@Component({
  selector: 'app-text-prompt-dialog',
  templateUrl: './text-prompt-dialog.component.html',
  standalone: true,
  imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatDialogModule, MatButtonModule, MatIconModule, MatError, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextPromptDialogComponent implements OnInit {
  readonly data = inject<TextInputData>(MAT_DIALOG_DATA);
  textControl = new FormControl('', { nonNullable: true });
  private readonly dialogRef = inject(MatDialogRef<TextPromptDialogComponent>);

  ngOnInit(): void {
    const validators = this.data.required ? [Validators.required] : [];
    this.textControl = new FormControl(this.data.initialValue || '', { validators, nonNullable: true });
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    if (this.textControl.valid) {
      this.dialogRef.close(this.textControl.value);
    }
  }
}
